const macRegex = /mac/i;

export const isMac = macRegex.test(window.navigator.platform);
